import { render, staticRenderFns } from "./OverviewInfo.vue?vue&type=template&id=25895dc4&scoped=true"
import script from "./OverviewInfo.vue?vue&type=script&lang=js"
export * from "./OverviewInfo.vue?vue&type=script&lang=js"
import style0 from "./OverviewInfo.vue?vue&type=style&index=0&id=25895dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25895dc4",
  null
  
)

export default component.exports